import React, { useContext, useState } from "react";

import { Link } from "react-router-dom";
import { Row, Col, Form, FloatingLabel, Button } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import "react-form-wizard-component/dist/style.css";

export default function CreateDonor() {
  const [values, setValues] = useState({
    firstName: "",
    lastName: "",
    organization: "",
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      setValues((prevState) => ({
        ...prevState,
        [name]: files[0],
      }));
    } else {
      setValues((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(values);
  };

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">{"Create Donor"}</h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {"home"}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {"Donor Management"}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">{"Add New Donor"}</li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>

      <div className="card">
        <div className="card-header">Add New</div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <Row>
              <Form.Group as={Col} md="6" controlId="validationCustom01">
                <FloatingLabel
                  controlId="floatingInputGrid"
                  label="Enter First Name"
                  className="mb-3"
                >
                  <Form.Control
                    required
                    type="text"
                    name="firstName"
                    placeholder="First Name"
                    value={values.firstName}
                    onChange={handleChange}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="validationCustom01">
                <FloatingLabel label="Enter Last Name" className="mb-3">
                  <Form.Control
                    required
                    type="text"
                    name="lastName"
                    placeholder="Last Name"
                    value={values.lastName}
                    onChange={handleChange}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="validationCustom01">
                <FloatingLabel label="Organization" className="mb-3">
                  <Form.Control
                    required
                    type="text"
                    name="organization"
                    placeholder="Organization"
                    value={values.organization}
                    onChange={handleChange}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="validationCustom01">
                <FloatingLabel label="Enter your Email" className="mb-3">
                  <Form.Control
                    required
                    type="email"
                    name="email"
                    placeholder="Enter your Email"
                    value={values.email}
                    onChange={handleChange}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="validationCustom01">
                <FloatingLabel label="Enter Password" className="mb-3">
                  <Form.Control
                    required
                    type="password"
                    name="password"
                    placeholder="Password"
                    value={values.password}
                    onChange={handleChange}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="validationCustom01">
                <FloatingLabel label="Select Family" className="mb-3">
                  <Form.Select
                    required
                    type="text"
                    name="selectFamily"
                    placeholder=""
                    value={values.selectFamily}
                    onChange={handleChange}
                  >
                    <option>Select...</option>
                    <option>FSF 1</option>
                    <option>FSF 2</option>
                  </Form.Select>
                </FloatingLabel>
              </Form.Group>
            </Row>
            <Button className="py-2 my-3" variant="success" type="submit">
              Submit
            </Button>
          </form>
        </div>
      </div>
    </PageLayout>
  );
}
